"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { CreateWaveDatesConfig } from "@/types/waves.types";
import type { ApiWaveType } from "@/generated/models/ApiWaveType";
import StartDates from "./StartDates";
import Decisions from "./Decisions";
import RollingEndDate from "./RollingEndDate";
import { adjustDatesAfterSubmissionChange, calculateEndDate, clampRollingEndDate, validateDateSequence } from "../services/waveDecisionService";
import { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import { Time } from "@/helpers/time";
interface CreateWaveDatesRankProps {
  readonly waveType: ApiWaveType;
  readonly dates: CreateWaveDatesConfig;
  readonly errors: CREATE_WAVE_VALIDATION_ERROR[];
  readonly setDates: (dates: CreateWaveDatesConfig) => void;
}
export default function CreateWaveDatesRank(t0) {
  const $ = _c(70);
  const {
    waveType,
    dates,
    errors,
    setDates
  } = t0;
  const isRollingMode = dates.isRolling;
  let t1;
  if ($[0] !== dates.isRolling) {
    t1 = {
      start: true,
      decisions: false,
      rolling: dates.isRolling
    };
    $[0] = dates.isRolling;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [expandedSections, setExpandedSections] = useState(t1);
  const [hasAutoCollapsedStart, setHasAutoCollapsedStart] = useState(false);
  const rankFutureDateError = CREATE_WAVE_VALIDATION_ERROR.RANK_DECISION_TIME_MUST_BE_IN_FUTURE;
  const endDateBeforeVotingStartError = CREATE_WAVE_VALIDATION_ERROR.END_DATE_MUST_BE_AFTER_VOTING_START_DATE;
  const firstDecisionBeforeVotingStartError = CREATE_WAVE_VALIDATION_ERROR.RANK_FIRST_DECISION_TIME_MUST_BE_AFTER_OR_EQUAL_TO_VOTING_START_DATE;
  let t2;
  if ($[2] !== errors) {
    t2 = errors.includes(rankFutureDateError);
    $[2] = errors;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const hasRankFutureDateError = t2;
  let t3;
  if ($[4] !== errors) {
    t3 = errors.includes(endDateBeforeVotingStartError);
    $[4] = errors;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const hasEndDateBeforeVotingStartError = t3;
  let t4;
  if ($[6] !== errors) {
    t4 = errors.includes(firstDecisionBeforeVotingStartError);
    $[6] = errors;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const hasFirstDecisionBeforeVotingStartError = t4;
  let t5;
  if ($[8] !== hasRankFutureDateError) {
    t5 = hasRankFutureDateError ? Time.currentMillis() : null;
    $[8] = hasRankFutureDateError;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const now = t5;
  const isFirstDecisionTimeInPast = now !== null && dates.firstDecisionTime <= now;
  let t6;
  if ($[10] !== dates.endDate || $[11] !== dates.isRolling || $[12] !== now) {
    t6 = now !== null && dates.isRolling && dates.endDate !== null && (!Number.isFinite(dates.endDate) || dates.endDate <= now);
    $[10] = dates.endDate;
    $[11] = dates.isRolling;
    $[12] = now;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const isRollingEndDateInPast = t6;
  let t7;
  if ($[14] !== dates.isRolling || $[15] !== errors || $[16] !== hasEndDateBeforeVotingStartError || $[17] !== hasFirstDecisionBeforeVotingStartError || $[18] !== hasRankFutureDateError || $[19] !== isFirstDecisionTimeInPast) {
    let t8;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = error => error !== rankFutureDateError && error !== endDateBeforeVotingStartError && error !== firstDecisionBeforeVotingStartError;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    const unroutedErrors = errors.filter(t8);
    let t9;
    if ($[22] !== hasFirstDecisionBeforeVotingStartError) {
      t9 = hasFirstDecisionBeforeVotingStartError ? [firstDecisionBeforeVotingStartError] : [];
      $[22] = hasFirstDecisionBeforeVotingStartError;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    let t10;
    if ($[24] !== dates.isRolling || $[25] !== hasEndDateBeforeVotingStartError) {
      t10 = hasEndDateBeforeVotingStartError && !dates.isRolling ? [endDateBeforeVotingStartError] : [];
      $[24] = dates.isRolling;
      $[25] = hasEndDateBeforeVotingStartError;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    let t11;
    if ($[27] !== dates.isRolling || $[28] !== hasRankFutureDateError || $[29] !== isFirstDecisionTimeInPast) {
      t11 = hasRankFutureDateError && (!dates.isRolling || isFirstDecisionTimeInPast) ? [rankFutureDateError] : [];
      $[27] = dates.isRolling;
      $[28] = hasRankFutureDateError;
      $[29] = isFirstDecisionTimeInPast;
      $[30] = t11;
    } else {
      t11 = $[30];
    }
    t7 = [...unroutedErrors, ...t9, ...t10, ...t11];
    $[14] = dates.isRolling;
    $[15] = errors;
    $[16] = hasEndDateBeforeVotingStartError;
    $[17] = hasFirstDecisionBeforeVotingStartError;
    $[18] = hasRankFutureDateError;
    $[19] = isFirstDecisionTimeInPast;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const decisionErrors = t7;
  let t8;
  if ($[31] !== dates.isRolling || $[32] !== hasEndDateBeforeVotingStartError) {
    t8 = hasEndDateBeforeVotingStartError && dates.isRolling ? [endDateBeforeVotingStartError] : [];
    $[31] = dates.isRolling;
    $[32] = hasEndDateBeforeVotingStartError;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== hasRankFutureDateError || $[35] !== isRollingEndDateInPast) {
    t9 = hasRankFutureDateError && isRollingEndDateInPast ? [rankFutureDateError] : [];
    $[34] = hasRankFutureDateError;
    $[35] = isRollingEndDateInPast;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== t8 || $[38] !== t9) {
    t10 = [...t8, ...t9];
    $[37] = t8;
    $[38] = t9;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  const rollingEndDateErrors = t10;
  let t11;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = sectionName => {
      setExpandedSections(prev => ({
        ...prev,
        [sectionName]: !prev[sectionName]
      }));
    };
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  const toggleSection = t11;
  let t12;
  if ($[41] !== dates || $[42] !== setDates) {
    t12 = nextDates => {
      let normalizedDates = nextDates;
      if (nextDates.submissionStartDate !== dates.submissionStartDate) {
        const normalizedTimeline = adjustDatesAfterSubmissionChange(dates, nextDates.submissionStartDate);
        normalizedDates = {
          ...nextDates,
          submissionStartDate: normalizedTimeline.submissionStartDate,
          votingStartDate: normalizedTimeline.votingStartDate,
          firstDecisionTime: normalizedTimeline.firstDecisionTime
        };
      }
      if (normalizedDates.isRolling) {
        normalizedDates = {
          ...normalizedDates,
          endDate: clampRollingEndDate(normalizedDates)
        };
      } else {
        normalizedDates = {
          ...normalizedDates,
          endDate: calculateEndDate(normalizedDates)
        };
      }
      const validationErrors = validateDateSequence(normalizedDates);
      if (validationErrors.length > 0) {
        console.warn("Date validation errors:", validationErrors);
      }
      setDates(normalizedDates);
    };
    $[41] = dates;
    $[42] = setDates;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  const commitDates = t12;
  let t13;
  if ($[44] !== hasAutoCollapsedStart) {
    t13 = () => {
      if (!hasAutoCollapsedStart) {
        setExpandedSections(_temp);
        setHasAutoCollapsedStart(true);
      }
    };
    $[44] = hasAutoCollapsedStart;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  const handleDecisionsInteraction = t13;
  let t14;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => {
      setExpandedSections(_temp2);
    };
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  const handleRollingEnabled = t14;
  let t15;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => toggleSection("start");
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== commitDates || $[49] !== dates || $[50] !== expandedSections.start || $[51] !== waveType) {
    t16 = <StartDates waveType={waveType} dates={dates} setDates={commitDates} isExpanded={expandedSections.start} setIsExpanded={t15} />;
    $[48] = commitDates;
    $[49] = dates;
    $[50] = expandedSections.start;
    $[51] = waveType;
    $[52] = t16;
  } else {
    t16 = $[52];
  }
  let t17;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => toggleSection("decisions");
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  let t18;
  if ($[54] !== commitDates || $[55] !== dates || $[56] !== decisionErrors || $[57] !== expandedSections.decisions || $[58] !== handleDecisionsInteraction) {
    t18 = <Decisions dates={dates} errors={decisionErrors} setDates={commitDates} onRollingEnabled={handleRollingEnabled} isExpanded={expandedSections.decisions} setIsExpanded={t17} onInteraction={handleDecisionsInteraction} />;
    $[54] = commitDates;
    $[55] = dates;
    $[56] = decisionErrors;
    $[57] = expandedSections.decisions;
    $[58] = handleDecisionsInteraction;
    $[59] = t18;
  } else {
    t18 = $[59];
  }
  let t19;
  if ($[60] !== commitDates || $[61] !== dates || $[62] !== expandedSections.rolling || $[63] !== isRollingMode || $[64] !== rollingEndDateErrors) {
    t19 = dates.subsequentDecisions.length > 0 && isRollingMode && <RollingEndDate dates={dates} errors={rollingEndDateErrors} setDates={commitDates} isExpanded={expandedSections.rolling} setIsExpanded={() => toggleSection("rolling")} />;
    $[60] = commitDates;
    $[61] = dates;
    $[62] = expandedSections.rolling;
    $[63] = isRollingMode;
    $[64] = rollingEndDateErrors;
    $[65] = t19;
  } else {
    t19 = $[65];
  }
  let t20;
  if ($[66] !== t16 || $[67] !== t18 || $[68] !== t19) {
    t20 = <div className="tw-space-y-4">{t16}{t18}{t19}</div>;
    $[66] = t16;
    $[67] = t18;
    $[68] = t19;
    $[69] = t20;
  } else {
    t20 = $[69];
  }
  return t20;
}
function _temp2(prev_1) {
  return prev_1.rolling ? prev_1 : {
    ...prev_1,
    rolling: true
  };
}
function _temp(prev_0) {
  return {
    ...prev_0,
    start: false
  };
}